import React from "react";
import cls from "./MflistExcelinput.module.css";

export default function BulkInputModeCards({ mode, setMode }) {
  return (
    <div className={cls.modeCards}>
      <button
        type="button"
        className={`${cls.modeCard} ${mode === "production" ? cls.modeCardActive : ""}`}
        onClick={() => setMode("production")}
      >
        <div className={cls.modeCardTitle}>실데이터입력 (엑셀)</div>
        <div className={cls.modeCardDesc}>
          엑셀 업로드 후 검증·실데이터 저장 (DB + 문자)
        </div>
      </button>
      <button
        type="button"
        className={`${cls.modeCard} ${mode === "training" ? cls.modeCardActive : ""}`}
        onClick={() => setMode("training")}
      >
        <div className={cls.modeCardTitle}>훈련모드 (자동입력)</div>
        <div className={cls.modeCardDesc}>
          더미 데이터 생성·검증 연습 (DB 저장 안 됨)
        </div>
      </button>
    </div>
  );
}
